<template>
    <!-- Modal -->
    <div class="modal fade client-reviews" id="writeReview" tabindex="-1" role="dialog"
        aria-labelledby="writeReviewLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="writeReviewLabel">Write a review for {{ stylist.first_name }} {{ stylist.last_name }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="resetReviewForm()">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body review-form-wrapper">
                    <form class="review-form-inner">
                        <div class="inputs-wrapper section-wrap" :class="stylist.next_available_review ? 'bg-white': ''">
                            <div v-if="!stylist.next_available_review" class="input-row">
                                <label for="review-rating">Review Rating*</label>
                                <select :class="!reviewRatingValid && review.rating === 0 ? 'error' : ''"
                                    v-model="review.rating" id="review-rating" required>
                                    <option disabled value="0">Rating</option>
                                    <option v-for="(ratingNumber, index) in 5" :value="ratingNumber" :key="index">
                                        {{ ratingNumber }} {{ ratingNumber > 1 ? "stars" : "star" }}
                                    </option>
                                </select>
                            </div>
                            <div v-if="!stylist.next_available_review" class="input-row">
                                <label for="rev-message ">Review Message*</label>
                                <textarea :class="!reviewMessageValid && review.message === '' ? 'error' : ''"
                                    name="message" id="rev-message" v-model.trim="review.message" cols="30" rows="5"
                                    title="Review Message" :placeholder="
                                        !reviewMessageValid ? 'Message field is required' : 'Please write your review'
                                    " required></textarea>
                            </div>
                            <div v-if="stylist.next_available_review" class="section-wrap next-review-available">{{ stylist.next_available_review }}</div>
                            <div v-if="!stylist.next_available_review" class="review-btn-wrap">
                                <button class="primary-btn extra-small mobile" type="button" v-on:click="saveProfileReview()">
                                    Submit Review
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from "../../services/api_endpoints";
import messages from "../../services/messages";
import $ from "jquery";

export default {
    name: "ClientReviews",
    props: {
        stylist: {
            type: Object,
        },
    },
    data: function () {
        return {
            reviews: [],
            appLink: "",
            review: {
                rating: 0,
                title: "",
                message: "",
            },
            user: null,
            statusMessage: "",
            reviewSubmitted: false,
            reviewRatingValid: true,
            reviewMessageValid: true,
        };
    },
    mounted: function () {
        $(document).on("hidden.bs.modal", "#writeReview", this.resetReviewForm);
    },
    beforeDestroy() {
        $(document).off("hidden.bs.modal", "#writeReview", this.resetReviewForm);
    },
    computed: {},
    methods: {
        saveProfileReview() {
            this.reviewRatingValid = !!this.review.rating;
            this.reviewMessageValid = !!this.review.message;

            if (this.reviewRatingValid && this.reviewMessageValid) {
                let data = {
                    rating: this.review.rating,
                    title: "",
                    text: this.review.message,
                    user_id: this.stylist.id,
                    web: 1,
                };

                this.$http.post(api.actions.save_profile_review, data).then(
                    function (response) {
                        if (response.data.error == false) {
                            this.statusMessage = response.message;
                            this.reviewSubmitted = true;
                            this.showReviewForm = false;
                            messages.successMessage(messages.GLOBAL_MESSAGES.SUBMITED_REVIEW);
                            this.$emit('reload-stylist');
                            $('#writeReview').modal('toggle');
                        }
                    }.bind(this),
                    function () {
                        return false;
                    }
                );
            }
        },
        resetReviewForm() {
            this.review.rating = 0;
            this.statusMessage = "";
            this.review.message = "";
        }
    },
};
</script>
